import { getAuth } from "firebase/auth";

// The single place the frontend attaches the signed-in user's Firebase ID token
// to a backend call. Cloud Functions verify this token to confirm the caller is
// a real TES user rather than anyone on the internet. Modeled on the one
// existing pattern in clientPortal.js.

// Returns the current user's ID token, or "" when signed out or on any error.
// Never throws — a token failure must not break the request it was decorating.
export const getIdTokenSafe = async () => {
  try {
    const user = getAuth().currentUser;
    return (user && (await user.getIdToken())) || "";
  } catch {
    return "";
  }
};

// fetch() with the Bearer token attached when a user is signed in. When signed
// out, the request goes tokenless and the backend guard will reject it.
export const authedFetch = async (url, options = {}) => {
  const idToken = await getIdTokenSafe();
  const headers = { ...(options.headers || {}) };
  if (idToken) headers.Authorization = `Bearer ${idToken}`;
  return fetch(url, { ...options, headers });
};
